import { Divider, Typography } from "@mui/material";

function MappingError({ problem }) {
  // problem = { unavailable: "columnName", fullname: "Member.member.ada_field", closeMatch: [ "potentialMatch1", "potentialMatch2" ... ]}
  const extraSpaces =
    problem["closeMatch"] &&
    problem["closeMatch"].some(
      (e) => e.startsWith(" ") || e.endsWith(" ") || e.includes("  ")
    );

  const Matches = () => {
    return (
      <>
        {problem.closeMatch.map((match) => {
          return (
            <Typography
              key={match}
              sx={{
                whiteSpace: "pre-wrap", // preserves whitespace
                fontFamily: "monospace",
              }}
            >
              <mark>{match}</mark>
            </Typography>
          );
        })}
      </>
    );
  };

  return (
    <>
      <Divider sx={{ margin: "12px 0" }} />
      <Typography>
        <i>{problem.unavailable}</i> is mapped to <i>{problem.fullname}</i>.
        <br />
        <b>
          The column <i>{problem.unavailable}</i> does not exist in your current
          data file.
        </b>
      </Typography>
      {problem.closeMatch && problem.closeMatch.length > 0 && (
        <>
          <Typography>Perhaps you meant one of the following:</Typography>
          <Matches />
        </>
      )}
      {extraSpaces && (
        <Typography>
          <b>
            Note that some of the column names in your file have extra spaces in
            their names.
          </b>
        </Typography>
      )}
    </>
  );
}

export default MappingError;
